export type ZoomLevel = 0.25 | 0.5 | 0.75 | 1 | 1.5 | 2;

export const ZOOM_LEVELS: ZoomLevel[] = [0.25, 0.5, 0.75, 1, 1.5, 2];

export const MAX_ZOOM = ZOOM_LEVELS[ZOOM_LEVELS.length - 1];

export const MIN_ZOOM = ZOOM_LEVELS[0];
